import { useEffect, useState } from 'preact/hooks'
import { i18n } from 'i18n/i18n'

import { SpinnerError } from 'models/calculator'

import { fetchSettings } from 'services/settings'
import { Domains, getDomainsFromAPI } from 'services/wp-api/domains-api'
import { isHttpErrorStatus } from 'utils/promise'

import { SETTINGS_KEYS } from '../config'

interface ForeignSettingsHookProps {
  setSpinnerError: (spinnerError: SpinnerError) => void
}

export const useForeignSettings = ({ setSpinnerError }: ForeignSettingsHookProps) => {
  const [domains, setDomains] = useState<Domains>({})
  const [currencies, setCurrencies] = useState<string[]>([])
  const [payoutOwner, setPayoutOwner] = useState<string[]>([])

  useEffect(() => {
    const fetchForeignSettings = async () => {
      try {
        const domainsResponse = await getDomainsFromAPI()
        const settings = await fetchSettings(SETTINGS_KEYS)

        const symbolsSorted = settings.currency?.symbols_sorted ?? []
        const currenciesNotSupported = settings['currencies-not-supported'] ?? []

        setDomains(domainsResponse)
        setCurrencies(symbolsSorted.filter((currency) => !currenciesNotSupported.includes(currency)))
        setPayoutOwner(settings['bank-transfer-countries']?.payout_owner ?? [])
      } catch (e: unknown) {
        setSpinnerError(
          isHttpErrorStatus(e, 429)
            ? { isErrorVisible: true, message: i18n('calculator.spinnerError.toManyRequests') }
            : { isErrorVisible: true },
        )
      }
    }

    fetchForeignSettings()
  }, [])

  return { domains, currencies, payoutOwner }
}
